import { store } from "src/store";
import { setAccess, setRefresh } from "../authSlice";
import authService from "./authService";

let inFlight: Promise<string> | null = null;

/**
 * Refreshes the session once, however many callers ask at the same time.
 *
 * The refresh token rides in an HttpOnly cookie the browser sends with the
 * request, so it is never readable here: callers must not gate on it. The
 * body carries the token from state only as a fallback for a client without
 * the cookie. Refresh tokens rotate and the old one is blacklisted, so two
 * refreshes in flight would invalidate each other: every caller shares the
 * one promise. Resolves to the new access token; rejects when the refresh
 * fails, which means the session is over.
 */
export const refreshSession = (): Promise<string> => {
  if (!inFlight) {
    const { refresh } = store.getState().auth;
    inFlight = authService
      .refreshToken(refresh)
      .then((data) => {
        if (!data?.access) throw new Error("No access token in refresh response");
        store.dispatch(setAccess(data.access));
        // Keep the fallback current: the one sent here is blacklisted now.
        if (data.refresh) store.dispatch(setRefresh(data.refresh));
        return data.access as string;
      })
      .finally(() => {
        inFlight = null;
      });
  }
  return inFlight;
};
